// extracted by mini-css-extract-plugin
export default {"openAppButton":"index_openAppButton_0VLgD"};